import React from 'react'
import { Section } from '../components/section'
import { Permission } from 'settings/schema'
import { PermissionToggle } from '../components/permissionToggle'

interface GeneralPermissionsSectionProps {
    isAdminGranted: boolean
    handlePermissionClick: (permission: Permission, granted: boolean) => void
}

export const GeneralPermissionsSection = ({
    isAdminGranted,
    handlePermissionClick,
}: GeneralPermissionsSectionProps) => (
    <Section title="General permissions" className="general-permissions">
        <div className="row">
            <PermissionToggle
                permission="access_analytics"
                handleClick={handlePermissionClick}
                disabled={isAdminGranted}
            />
        </div>
        <div className="row">
            <PermissionToggle permission="access_codes" handleClick={handlePermissionClick} disabled={isAdminGranted} />
        </div>
    </Section>
)
